import LoaderFullScreen from './LoaderFullScreen';

export default LoaderFullScreen;
